import React from "react";
import { Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import Markdown from "~/components/Markdown";
import styled from "styled-components";
import TopicAISummaryRevenueCard from "../TopicAISummaryRevenueCard";
const List = styled.ul`
  margin-left: 1em;
`;
const ListItem = styled.li`
  margin-bottom: 0.5em;
`;
const TopicAISummary = _ref => {
  let {
    summary
  } = _ref;
  const {
    t
  } = useTranslation();
  const parsedSummary = summary.startsWith("{") ? JSON.parse(summary) : undefined;
  const hasRevenueChanges = parsedSummary?.revenue ? Object.values(parsedSummary.revenue).some(item => item.amount !== 0 || item.tcv !== 0 || item.count !== 0) : false;
  return parsedSummary ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Markdown, {
    element: "p",
    lineHeight: 5.5,
    fontSize: 4,
    text: parsedSummary.summaryShort
  }), /*#__PURE__*/React.createElement(Markdown, {
    element: "p",
    lineHeight: 5.5,
    fontSize: 4,
    text: parsedSummary.summary,
    s: {
      mt: 3,
      mb: 1
    }
  }), !!parsedSummary.revenue && hasRevenueChanges && /*#__PURE__*/React.createElement(TopicAISummaryRevenueCard, {
    revenue: parsedSummary.revenue
  }), /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    weight: "semiBold",
    display: "block",
    s: {
      mt: 5,
      mb: 3
    }
  }, t("TopicAISummarizeCard.blockers")), parsedSummary.blockers?.length ? /*#__PURE__*/React.createElement(List, null, parsedSummary.blockers.map((blocker, index) => /*#__PURE__*/React.createElement(ListItem, {
    key: index
  }, /*#__PURE__*/React.createElement(Markdown, {
    lineHeight: 5.5,
    fontSize: 4,
    text: blocker.description
  })))) : /*#__PURE__*/React.createElement(Text, {
    fontSize: 4
  }, t("TopicAISummarizeCard.noBlockers")), /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    weight: "semiBold",
    display: "block",
    s: {
      mt: 5,
      mb: 3
    }
  }, t("TopicAISummarizeCard.achievements")), parsedSummary.achievements?.length ? /*#__PURE__*/React.createElement(List, null, parsedSummary.achievements.map((achievement, index) => /*#__PURE__*/React.createElement(ListItem, {
    key: index
  }, /*#__PURE__*/React.createElement(Markdown, {
    lineHeight: 5.5,
    fontSize: 4,
    text: achievement.description
  })))) : /*#__PURE__*/React.createElement(Text, {
    fontSize: 4
  }, t("TopicAISummarizeCard.noAchievements")), /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    weight: "semiBold",
    display: "block",
    s: {
      mt: 5,
      mb: 3
    }
  }, t("TopicAISummarizeCard.actionItems")), parsedSummary.actionItems?.length ? /*#__PURE__*/React.createElement(List, null, parsedSummary.actionItems.map((actionItem, index) => /*#__PURE__*/React.createElement(ListItem, {
    key: index
  }, /*#__PURE__*/React.createElement(Markdown, {
    lineHeight: 5.5,
    fontSize: 4,
    text: actionItem.description
  })))) : /*#__PURE__*/React.createElement(Text, {
    fontSize: 4
  }, t("TopicAISummarizeCard.noActionItems"))) : /*#__PURE__*/React.createElement(Markdown, {
    element: "p",
    lineHeight: 5.5,
    fontSize: 4,
    text: summary
  });
};
export default TopicAISummary;